import {orderJobType} from "../OrderJobType";
import {modelParameterUnit} from "../ModelParameterUnit";
import {millingJob} from "../MillingJobType";
import {grooveType} from "../GrooveType";
import {contourType} from "../ContourType";
import {toolType} from "../ToolType";
import {gluing} from "../Gluing";
import {edgeEnd} from "../EdgeEnd";
import {edgeJob} from "../EdgeJob";
import {typeMaterialWithSubtype} from "../TypeMaterial";

const allMaterials = Object.values(typeMaterialWithSubtype)
const allSubMaterials = allMaterials.reduce((acc, el) => {
    return [...acc, ...Object.entries(el.subtype)]
}, [])

export const JobMetricOrganizationFilterData = [
    {
        "idFromColumnFilter": "name",
        "id": "name"
    },
    {
        "idFromColumnFilter": "metricName",
        "id": "metricName"
    },
    {
        "idFromColumnFilter": "restrictionsQuantityFrom",
        "id": "restrictionsQuantityFrom"
    },
    {
        "idFromColumnFilter": "restrictionsQuantityTo",
        "id": "restrictionsQuantityTo"
    },
    {
        "idFromColumnFilter": "thicknessMaterialFrom",
        "id": "thicknessMaterialFrom"
    },
    {
        "idFromColumnFilter": "thicknessMaterialTo",
        "id": "thicknessMaterialTo"
    },
    {
        "idFromColumnFilter": "depthHoleTo",
        "id": "depthHoleTo"
    },
    {
        "idFromColumnFilter": "depthHoleFrom",
        "id": "depthHoleFrom"
    },
    {
        "idFromColumnFilter": "diameterHoleTo",
        "id": "diameterHoleTo"
    },
    {
        "idFromColumnFilter": "diameterHoleFrom",
        "id": "diameterHoleFrom"
    },
    {
        "idFromColumnFilter": "basePrice",
        "id": "basePrice", "field": "price",
        "filterFn": (value, filterValue) => value?.toFixed(2).includes(filterValue)
    },
    {
        "idFromColumnFilter": "alternativePrice",
        "id": "alternativePrice", "field": "price",
        "filterFn": (value, filterValue) => value?.toFixed(2).includes(filterValue)
    },
    {
        "idFromColumnFilter": "unit",
        "id": "unit", "field": "name",
    },
    {
        "idFromColumnFilter": "compactPlate",
        "id": "compactPlate"
    },
    {
        "idFromColumnFilter": "necessarily",
        "id": "necessarily"
    },
    {
        "idFromColumnFilter": "detail",
        "id": "detail"
    },
    {
        "idFromColumnFilter": "display",
        "id": "display"
    },
    {
        "idFromColumnFilter": "millingEnd",
        "id": "millingEnd"
    },
    {
        "idFromColumnFilter": "smallSizedPart",
        "id": "smallSizedPart"
    },
    {
        "idFromColumnFilter": "overSizedPart",
        "id": "overSizedPart"
    },
    {
        "idFromColumnFilter": "drillingEnd",
        "id": "drillingEnd"
    },
    {
        "idFromColumnFilter": "curvilinearEdge",
        "id": "curvilinearEdge"
    },
    {
        "idFromColumnFilter": "added",
        "id": "added"
    },
    {
        "idFromColumnFilter": "subTypeMaterial",
        "id": "subTypeMaterial",
        "filterFn": (value, filterValue) => {
            const subMaterial = allSubMaterials.find(el => el[0] === value)
            return subMaterial && subMaterial[1]?.toLowerCase().includes(filterValue.toLowerCase())
        }
    },
    {
        "idFromColumnFilter": "orderJobType",
        "id": "orderJobType",
        "filterFn": (value, filterValue) => orderJobType[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "modelParameterUnit",
        "id": "modelParameterUnit",
        "filterFn": (value, filterValue) => modelParameterUnit[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },

    {
        "idFromColumnFilter": "millingJob",
        "id": "millingJob",
        "filterFn": (value, filterValue) => millingJob[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "grooveType",
        "id": "grooveType",
        "filterFn": (value, filterValue) => grooveType[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "contourType",
        "id": "contourType",
        "filterFn": (value, filterValue) => contourType[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "tool",
        "id": "tool",
        "filterFn": (value, filterValue) => toolType[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "edgeJob",
        "id": "edgeJob",
        "filterFn": (value, filterValue) => edgeJob[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "edgeEnd",
        "id": "edgeEnd",
        "filterFn": (value, filterValue) => edgeEnd[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
    {
        "idFromColumnFilter": "edgeType",
        "id": "edgeType",
        "filterFn": (value, filterValue) => gluing[value]?.toLowerCase().includes(filterValue.toLowerCase())
    },
]